var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotofindLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.847,
    height: 50.014,
    viewBox: "0 0 126.847 50.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photofind-logo-light.ca50a6532122b499f09d2bb6e1c60c83",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61786",
    "data-name": "Group 61786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61784",
    "data-name": "Group 61784",
    transform: "translate(31.914 30.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82338",
    "data-name": "Path 82338",
    d: "M192.6,186.018H198a4.472,4.472,0,0,1,1.983.4,3.611,3.611,0,0,1,1.3,1.041,4.078,4.078,0,0,1,.708,1.471,6.69,6.69,0,0,1,.214,1.684,5.446,5.446,0,0,1-.355,2.07,3.74,3.74,0,0,1-.987,1.427,4.146,4.146,0,0,1-1.533.837,6.743,6.743,0,0,1-2,.279h-1.652v6.115H192.59V186.018Zm3.089,6.928h1.374a2.036,2.036,0,0,0,1.491-.558,2.347,2.347,0,0,0,.568-1.738,2.685,2.685,0,0,0-.494-1.76,2.03,2.03,0,0,0-1.652-.6h-1.288v4.655Z",
    transform: "translate(-192.59 -185.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82339",
    "data-name": "Path 82339",
    d: "M256.08,186.02h2.961v4.955h.043a2.994,2.994,0,0,1,2.81-1.48,2.921,2.921,0,0,1,2.177.772,3.483,3.483,0,0,1,.761,2.511v8.559h-2.958v-7.96a1.981,1.981,0,0,0-.3-1.254,1.2,1.2,0,0,0-.964-.355q-1.566,0-1.566,1.909v7.659H256.08Z",
    transform: "translate(-245.559 -185.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82340",
    "data-name": "Path 82340",
    d: "M315.949,213.058a12.946,12.946,0,0,1,.235-2.617,5.051,5.051,0,0,1,.772-1.9,3.433,3.433,0,0,1,1.4-1.158,5.119,5.119,0,0,1,2.134-.4,5.413,5.413,0,0,1,2.209.355,3.1,3.1,0,0,1,1.4,1.148,5.124,5.124,0,0,1,.729,1.92,14.61,14.61,0,0,1,.214,2.65,12.865,12.865,0,0,1-.235,2.617,5.039,5.039,0,0,1-.772,1.9,3.42,3.42,0,0,1-1.405,1.158,5.118,5.118,0,0,1-2.134.4,5.408,5.408,0,0,1-2.209-.355,3.1,3.1,0,0,1-1.4-1.148,5.122,5.122,0,0,1-.729-1.909,14.537,14.537,0,0,1-.214-2.66Zm2.961,0q0,.88.043,1.631a5.606,5.606,0,0,0,.2,1.288,1.9,1.9,0,0,0,.472.837,1.2,1.2,0,0,0,.868.3,1.255,1.255,0,0,0,1.245-.945,14.274,14.274,0,0,0,0-6.221A1.254,1.254,0,0,0,320.5,209a1.2,1.2,0,0,0-.868.3,1.9,1.9,0,0,0-.472.837,5.608,5.608,0,0,0-.2,1.288C318.923,211.928,318.91,212.471,318.91,213.058Z",
    transform: "translate(-295.508 -203.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82341",
    "data-name": "Path 82341",
    d: "M373.111,188.87h2.959v3.3h1.716v2.017H376.07v6.241a1.757,1.757,0,0,0,.2.976.988.988,0,0,0,.847.29q.171,0,.343-.01c.114-.007.222-.018.322-.031v2.06q-.495.042-.954.086t-.976.043a5.356,5.356,0,0,1-1.415-.152,1.573,1.573,0,0,1-.825-.5,2.017,2.017,0,0,1-.4-.933,8.243,8.243,0,0,1-.108-1.458v-6.6h-1.5v-2.017h1.5v-3.3Z",
    transform: "translate(-341.945 -188.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82342",
    "data-name": "Path 82342",
    d: "M410.679,213.058a12.953,12.953,0,0,1,.235-2.617,5.05,5.05,0,0,1,.772-1.9,3.433,3.433,0,0,1,1.4-1.158,5.118,5.118,0,0,1,2.134-.4,5.413,5.413,0,0,1,2.209.355,3.1,3.1,0,0,1,1.4,1.148,5.124,5.124,0,0,1,.729,1.92,14.607,14.607,0,0,1,.214,2.65,12.856,12.856,0,0,1-.235,2.617,5.039,5.039,0,0,1-.772,1.9,3.419,3.419,0,0,1-1.4,1.158,5.119,5.119,0,0,1-2.134.4,5.409,5.409,0,0,1-2.209-.355,3.1,3.1,0,0,1-1.4-1.148,5.125,5.125,0,0,1-.73-1.91,14.548,14.548,0,0,1-.214-2.66Zm2.961,0q0,.88.043,1.631a5.607,5.607,0,0,0,.2,1.288,1.9,1.9,0,0,0,.472.837,1.2,1.2,0,0,0,.868.3,1.255,1.255,0,0,0,1.245-.945,14.274,14.274,0,0,0,0-6.221,1.254,1.254,0,0,0-1.245-.945,1.2,1.2,0,0,0-.868.3,1.9,1.9,0,0,0-.472.837,5.607,5.607,0,0,0-.2,1.288C413.653,211.928,413.64,212.471,413.64,213.058Z",
    transform: "translate(-374.539 -203.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82343",
    "data-name": "Path 82343",
    d: "M468.561,190.3h-1.5v-2.017h1.5v-1.309a3.542,3.542,0,0,1,.214-1.309,2.06,2.06,0,0,1,.611-.858,2.436,2.436,0,0,1,.976-.461,5.516,5.516,0,0,1,1.288-.139q.773,0,1.588.064v2.1a1.567,1.567,0,0,0-.3-.021h-.276a1.4,1.4,0,0,0-.88.214.871.871,0,0,0-.257.708v1.008h1.717V190.3h-1.717v9.525h-2.961V190.3Z",
    transform: "translate(-421.578 -184.209)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22886",
    "data-name": "Rectangle 22886",
    width: 2.829,
    height: 2.419,
    transform: "translate(52.395 0.283)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22887",
    "data-name": "Rectangle 22887",
    width: 2.961,
    height: 11.542,
    transform: "translate(52.395 4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82344",
    "data-name": "Path 82344",
    d: "M536.98,207.3h2.832v1.352h.043a3,3,0,0,1,1.223-1.254,3.609,3.609,0,0,1,1.717-.4,2.921,2.921,0,0,1,2.177.772,3.483,3.483,0,0,1,.761,2.511v8.559h-2.958v-7.96a1.983,1.983,0,0,0-.3-1.254,1.2,1.2,0,0,0-.964-.355q-1.566,0-1.566,1.909v7.659H536.98Z",
    transform: "translate(-479.912 -203.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82345",
    "data-name": "Path 82345",
    d: "M602.58,200.116h-.043a3.262,3.262,0,0,1-1.105,1.17,2.984,2.984,0,0,1-1.513.355,2.9,2.9,0,0,1-2.681-1.427,12.994,12.994,0,0,1,0-9.289,2.905,2.905,0,0,1,2.681-1.427,2.794,2.794,0,0,1,1.427.343,3.37,3.37,0,0,1,1.062,1.029h.043v-4.85h2.961v15.316H602.58Zm-3.24-4.547a10.41,10.41,0,0,0,.29,2.841,1.21,1.21,0,0,0,1.254.954,1.232,1.232,0,0,0,1.276-.954,14.071,14.071,0,0,0,0-5.683,1.221,1.221,0,0,0-1.276-.954,1.2,1.2,0,0,0-1.254.954,10.413,10.413,0,0,0-.29,2.841Z",
    transform: "translate(-529.469 -185.72)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61785",
    "data-name": "Group 61785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82346",
    "data-name": "Path 82346",
    d: "M33.342,13.595v3.117H19.58a2.869,2.869,0,0,0-2.87,2.868v13.8H0V13.593A13.594,13.594,0,0,1,13.593,0h6.156A13.6,13.6,0,0,1,33.344,13.595",
    transform: "translate(0 0)",
    fill: "#6711ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82347",
    "data-name": "Path 82347",
    d: "M16.71,201.44v3.039A13.6,13.6,0,0,1,3.115,218.074H.749A.748.748,0,0,1,0,217.325V201.443H16.71Z",
    transform: "translate(0 -168.06)",
    fill: "#00b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82348",
    "data-name": "Path 82348",
    d: "M117.463,100.84v3.039a13.6,13.6,0,0,1-13.595,13.595h-3.039V103.708a2.87,2.87,0,0,1,2.87-2.868h13.762Z",
    transform: "translate(-84.121 -84.13)",
    fill: "#00eaaf"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_82349",
    "data-name": "Path 82349",
    d: "M662.175,257.74v3.434h-2.9V257.74Z",
    transform: "translate(-550.024 -215.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82350",
    "data-name": "Path 82350",
    d: "M685.43,182.58h3.037v2.6H685.43Zm0,4.048h3.037v11.839H685.43Z",
    transform: "translate(-571.849 -152.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82351",
    "data-name": "Path 82351",
    d: "M711.312,205.463h2.9v1.387h.044a3.086,3.086,0,0,1,1.254-1.288,3.7,3.7,0,0,1,1.76-.406,3,3,0,0,1,2.233.792,3.573,3.573,0,0,1,.78,2.575V217.3h-3.037v-8.164a2.029,2.029,0,0,0-.308-1.288,1.232,1.232,0,0,0-.991-.363q-1.606,0-1.606,1.959V217.3H711.31V205.463Z",
    transform: "translate(-593.441 -171.158)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotofindLogo);
export default __webpack_public_path__ + "static/media/photofind-logo.984f804f4de7fc6c7d8234ee49677fb8.svg";
export { ForwardRef as ReactComponent };